import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getTeam } from '../api/teamApi'
import { Team } from '../types'

export default function useTeam(options?: SWRConfiguration) {
  return useSWR<Team, Error>('my-team', getTeam, options)
}
